var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"icons / check-mark"}},[_c('path',{staticClass:"checkmark-path",attrs:{"stroke-width":"1.75","stroke-miterlimit":"10","d":"M4.7,10.7L4.7,10.7c5,5,5,5,5,5l10-10l0,0l0,0","stroke":_vm.fill}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }